/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Consumer_HintInputs */

const vi_order_form_invoice_buyer_consumer_hint = /** @type {(inputs: Order_Form_Invoice_Buyer_Consumer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ ghi họ tên người mua. Nếu để trống, hóa đơn ghi “Bán cho người tiêu dùng”.`)
};

/**

* @param {Order_Form_Invoice_Buyer_Consumer_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_consumer_hint = /** @type {((inputs?: Order_Form_Invoice_Buyer_Consumer_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Consumer_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_consumer_hint(inputs)
});